import {Component, inject} from '@angular/core';
import {Location} from "@angular/common";
import {AllMastersDatabaseService} from "../service/all-masters-database.service";

@Component({
    selector: 'app-master-details-wrapper',
    templateUrl: './master-details-wrapper.component.html',
    styleUrls: ['./master-details-wrapper.component.css']
})
export class MasterDetailsWrapperComponent {

    public ecuBuild: string;
    allMastersService = inject(AllMastersDatabaseService);
    constructor(private location: Location) {
    }

    backToMainScreen() {
        this.location.back();
    }
}
